/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Dialogue_List_Export_Failed_ToastInputs */

const en_dialogue_list_export_failed_toast = /** @type {(inputs: Dialogue_List_Export_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Dialogue List Export failed: ${i?.error}`)
};

const fr_dialogue_list_export_failed_toast = /** @type {(inputs: Dialogue_List_Export_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Échec de l'exportation de la liste des dialogues : ${i?.error}`)
};

const de_dialogue_list_export_failed_toast = /** @type {(inputs: Dialogue_List_Export_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Dialoglistenexport fehlgeschlagen: ${i?.error}`)
};

const it_dialogue_list_export_failed_toast = /** @type {(inputs: Dialogue_List_Export_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Esportazione elenco dialoghi fallita: ${i?.error}`)
};

const ru_dialogue_list_export_failed_toast = /** @type {(inputs: Dialogue_List_Export_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Экспорт списка диалогов не удался: ${i?.error}`)
};

const es_dialogue_list_export_failed_toast = /** @type {(inputs: Dialogue_List_Export_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Error en la exportación de la lista de diálogo: ${i?.error}`)
};

const zh_cn2_dialogue_list_export_failed_toast = /** @type {(inputs: Dialogue_List_Export_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`对话列表导出失败：${i?.error}`)
};

const ja_dialogue_list_export_failed_toast = /** @type {(inputs: Dialogue_List_Export_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ダイアログリストのエクスポートに失敗しました: ${i?.error}`)
};

const hi_dialogue_list_export_failed_toast = /** @type {(inputs: Dialogue_List_Export_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`संवाद सूची निर्यात विफल: ${i?.error}`)
};

const pt_pt2_dialogue_list_export_failed_toast = /** @type {(inputs: Dialogue_List_Export_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Falha na exportação da lista de diálogos: ${i?.error}`)
};

/**
* | output |
* | --- |
* | "Dialogue List Export failed: {error}" |
*
* @param {Dialogue_List_Export_Failed_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const dialogue_list_export_failed_toast = /** @type {((inputs: Dialogue_List_Export_Failed_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialogue_List_Export_Failed_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_dialogue_list_export_failed_toast(inputs)
	if (locale === "de") return de_dialogue_list_export_failed_toast(inputs)
	if (locale === "it") return it_dialogue_list_export_failed_toast(inputs)
	if (locale === "ru") return ru_dialogue_list_export_failed_toast(inputs)
	if (locale === "es") return es_dialogue_list_export_failed_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_dialogue_list_export_failed_toast(inputs)
	if (locale === "ja") return ja_dialogue_list_export_failed_toast(inputs)
	if (locale === "hi") return hi_dialogue_list_export_failed_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_dialogue_list_export_failed_toast(inputs)
	return en_dialogue_list_export_failed_toast(inputs)
});